import { render, staticRenderFns } from "./BackNav.vue?vue&type=template&id=535167d2"
import script from "./BackNav.vue?vue&type=script&lang=js"
export * from "./BackNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports